import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import LoadingView from '../views/Loading';
import { postIntroState } from '../utils/navigation';
import useLinkNavigate from '../hooks/useLinkNavigate';
import { useAppSelector } from '../state';
import { selectFeatureFlags, selectLinkTokenPayload, } from '../state/slices/slice-link-params';
import { ScreenLoadingSkeleton } from '../views/ScreenLoadingSkeleton';
import { DepositFormsExperience } from '../types/dd-forms';
import { useDDFormContext } from '../hooks/useDDFormContext';
export function defineFirstRoute(linkTokenPayload, featureFlags) {
    if (linkTokenPayload.skipIntroScreen ||
        // If user is in the App Clip, the user was already shown the intro screen
        // on the source app so don't show it again. Note that if skip_intro_screen
        // was set in the token, then the ToS links would have already been shown on
        // the app clip primer screen, so the intro screen isn't needed here either.
        linkTokenPayload.isAppClip) {
        return postIntroState(linkTokenPayload, featureFlags);
    }
    return '/intro';
}
var AppPreload = function () {
    var linkTokenPayload = useSelector(selectLinkTokenPayload);
    var navigate = useLinkNavigate();
    var featureFlags = useAppSelector(selectFeatureFlags);
    var setDDFormEntryPoint = useDDFormContext().setDDFormEntryPoint;
    useEffect(function () {
        if (linkTokenPayload.depositForms === DepositFormsExperience.DIRECT) {
            setDDFormEntryPoint('direct_launch');
        }
        var pathname = defineFirstRoute(linkTokenPayload, featureFlags);
        navigate(pathname);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (featureFlags.screenTransitionLoadingSkeleton) {
        return React.createElement(ScreenLoadingSkeleton, null);
    }
    return React.createElement(LoadingView, null);
};
export default AppPreload;
